module.exports = __webpack_public_path__ + "static/img/product3-1.14148ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product3-1.jpg
// module id = QFjb
// module chunks = 0